@if (control) {
  <mat-form-field class="w-100 legacy-field">
    <mat-label>{{ control.caption | translate }}</mat-label>
    <input
      #searchInput
      matInput
      type="text"
      autocomplete="off"
      placeholder="{{ 'COMMON.TYPE_TO_SEARCH' | translate }}"
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      [readonly]="control.isReadonly"
      (focus)="onFocus()"
      (blur)="onBlur()"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="onOptionSelected($event)"
        (optionsInfiniteScroll)="onOptionsScroll($event)"
        [pageLoaded]="pageLoaded"
        >
        @for (item of displayItems; track item) {
          <mat-option [value]="item.name">
            <mat-pseudo-checkbox [state]="isSelected(item) ? 'checked' : 'unchecked'"></mat-pseudo-checkbox>
            <span class="option-text">{{ item.name }}</span>
          </mat-option>
        }
        @if (!displayItems?.length) {
          <mat-option [disabled]="true">
            {{ 'COMMON.SEARCH_RESULT_EMPTY' | translate }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }

  <!-- Controls (on :hover) -->
  @if (selectedItems.length && !control.isReadonly) {
    <div class="_controls">
      @if (showClearOthers) {
        <div class="_control _control__clear-others" (click)="addonClicked()"></div>
      }
      <div class="_control _control__clear-this" (click)="clearAll()">&#10005;</div>
    </div>
  }
